module.exports = __webpack_public_path__ + "static/media/Bulletproof1.68631704.jpg";